export const aggregationStatusBarConfig = {
  statusPanels: [
    {
      statusPanel: 'agAggregationComponent',
      align: 'left',
      statusPanelParams: {
        aggFuncs: ['sum', 'avg', 'count'],
      },
    },
  ],
};
